// Links such as #store-payment open a card of the Store settings tab (see AdminPanel + StoreSettingsForm).
// Used as the onClick of those links, so they also work when the address already ends in that #hash.
export function openSettingsSection(event) {
  const hash = event.currentTarget.getAttribute("href");
  event.preventDefault();
  window.history.replaceState(null, "", hash);
  window.dispatchEvent(new HashChangeEvent("hashchange"));
  document.querySelector(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
}
